"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var microsoftTeams = require("@microsoft/teams-js");
require("./signin-page.scss");
var SignInPage = function (props) {
    function onSignIn() {
        microsoftTeams.initialize();
        microsoftTeams.authentication.authenticate({
            url: window.location.origin + "/signin-simple-start",
            successCallback: function () {
                console.log("Login succeeded!");
                window.location.href = "/list-serventias";
            },
            failureCallback: function (reason) {
                console.log("Login failed: " + reason);
                window.location.href = "/errorpage";
            }
        });
    }
    return (React.createElement("div", { className: "sign-in-content-container" },
        React.createElement(react_northstar_1.Text, { content: "Clique aqui para efetuar seu login.", size: "medium" }),
        React.createElement("div", { className: "space" }),
        React.createElement(react_northstar_1.Button, { content: "Login", primary: true, className: "sign-in-button", onClick: onSignIn })));
};
exports.default = SignInPage;
//# sourceMappingURL=signin.js.map